/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BUTTON_FORMAT_SOFT, BUTTON_THEME_DEFAULT, Button, ButtonProps } from '@squiz/sds';
import { getCapabilityPath } from 'apps/console-core/src/Utilities/GetCapabilityPath/GetCapabilityPath';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CDP_STRINGS } from '../../../../Constants/Strings.constants';
import { DiscardChangesProps } from './DiscardChanges.props';

/**
 * The discard changes button component with confirmation dialog.
 */
export const DiscardChanges = (props: DiscardChangesProps): JSX.Element => {
  const { isLoading } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      discardChangesButton: t(CDP_STRINGS.cancel),
    };
  }, [t]);

  const handleDiscardChange = (): void => {
    navigate({ pathname: getCapabilityPath(`/segmentation`) });
  };

  const buttonProps: ButtonProps = {
    disabled: isLoading,
    format: BUTTON_FORMAT_SOFT,
    onClick: handleDiscardChange,
    text: labels.discardChangesButton,
    theme: BUTTON_THEME_DEFAULT,
  };

  // @ts-ignore.
  return <Button {...buttonProps} />;
};
